import { type RefObject, useLayoutEffect, useState } from 'react'

export const useIsOverflow = (ref: RefObject<HTMLElement | null>) => {
  const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined)

  useLayoutEffect(() => {
    const trigger = () => {
      if (!ref.current) return

      const hasOverflow = ref.current.scrollHeight > ref.current.clientHeight

      setIsOverflow(hasOverflow)
    }

    window.addEventListener('resize', trigger)

    return () => window.removeEventListener('resize', trigger)
  }, [ref])

  return isOverflow
}
